module.exports = __webpack_public_path__ + "media/1.0bd901f2.wav";